// Raw external labels are never parsed as IDs or rewritten before resolution.
export async function resolveLocationScan(service, raw, warehouse) {
  if (typeof raw !== 'string' || !raw.replace(/[\r\n]+$/, '')) {
    throw new Error('Scan a location label');
  }
  const originalRaw = raw.replace(/[\r\n]+$/, '');
  if (/^S\/P\/[1-9][0-9]*\*$/.test(originalRaw)) {
    return { raw: originalRaw, value: originalRaw.slice(4, -1), type: 'S/P' };
  }
  if (!warehouse) throw new Error('Select a warehouse');
  const result = await service.identifierRequest({ action: 'resolve', raw: originalRaw, warehouse, context: 'location' });
  if (!result || result.kind !== 'location' || !result.id || !result.internalCode) {
    throw new Error('Location resolution is unavailable');
  }
  return { raw: result.internalCode, value: String(result.id), type: 'S/P', originalRaw,
    locationUuid: result.uuid, locationIdentifier: result.identifierId, locationWarehouse: result.warehouse };
}

export function locationScanPayload(barcode) {
  return barcode && barcode.originalRaw ? { locationScan: barcode.originalRaw } : {};
}

// TSV keeps identifiers as strings; never pass warehouse labels through a spreadsheet number parser.
export function parseAliasImport(text) {
  const lines = text.replace(/\r\n/g, '\n').replace(/\n$/, '').split('\n');
  if (!text || lines.length > 200) throw new Error('Import requires 1 to 200 rows');
  return lines.map((line, index) => {
    const fields = line.split('\t');
    if (fields.length !== 2 || !fields[1]) throw new Error(`Invalid row ${index + 1}`);
    const match = /^S\/P\/([1-9][0-9]*)\*$/.exec(fields[0]);
    const place = match ? match[1] : fields[0];
    if (!/^[1-9][0-9]*$/.test(place) && !/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(place)) throw new Error(`Invalid location on row ${index + 1}`);
    return { place, raw: fields[1] };
  });
}
